module.exports = __webpack_public_path__ + "img/433.31c3394b.jpg";